import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-content">
        <div className="newsletter">
          <img src="images/rclogo.png" alt="rojen_canadalogo" width={'40%'} />
          {/* <h2>News Letter</h2>
          <p>Our team comprises professionals with experience</p>
          <a href="mailto:info@support.com">info@support.com</a>
          <div className="email-input">
            <input type="email" placeholder="Email Address" />
            <button>→</button>
          </div> */}
        </div>
        {/* <div className="links">
          <h2>Visa</h2>
          <ul>
            <li><i class="fa-solid fa-chevron-right" style={{color: '#b80404'}}></i> &nbsp;Migration Visas</li>
            <li><i class="fa-solid fa-chevron-right" style={{color: '#b80404'}}></i>&nbsp; Diplomatic Visa</li>
            <li><i class="fa-solid fa-chevron-right" style={{color: '#b80404'}}></i> &nbsp;Residence Visa</li>
            <li><i class="fa-solid fa-chevron-right" style={{color: '#b80404'}}></i> &nbsp;Student Visa</li>
            <li><i class="fa-solid fa-chevron-right" style={{color: '#b80404'}}></i> &nbsp;Business Visa</li>
          </ul>
        </div> */}
        <div className="quick-links">
          <h2>Quick Links</h2>
          <ul>

            <li>
              <Link to="/aboutus" style={{ textDecoration: "none", color: "inherit" }}>
                <i className="fa-solid fa-chevron-right" style={{ color: "#b80404" }}></i> &nbsp;About Us
              </Link>
            </li>

            {/* <li>
            <a href="/" style={{ textDecoration: "none", color: "inherit" }}>
              <i class="fa-solid fa-chevron-right" style={{color: '#b80404'}}></i> &nbsp;Testimonial
              </a>
              </li> */}
            <li>
              <Link to="/contactus" style={{ textDecoration: "none", color: "inherit" }}>
                <i className="fa-solid fa-chevron-right" style={{ color: "#b80404" }}></i> &nbsp;Contact Us
              </Link>
            </li>
          </ul>
        </div>
        <div className="contact-info">
          <h2>Contact Info</h2>
          {/* <p>
            <span> <i class="fa-solid fa-location-dot fa-xl" style={{color: '#b80404'}}></i> </span>&nbsp;&nbsp;
           <span>934 McCowan Road, Toronto M1P 3H6</span></p> */}
          {/* <p><i class="fa-solid fa-headset fa-xl" style={{color: '#b80404'}}></i>&nbsp;&nbsp;+1 (647) 716-1330</p> */}

          <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;<a href="mailto:info@hegira.com">info@rojancanada.com</a>
        </div>
      </div>
      <div className="footer-bottom">
        <h6>
          © Rojan Canada Copyright 2024. All Rights Reserved. Designed by{" "}
          <span><a href="https://dgbirdmedia.com/" style={{ textDecorationLine: 'none', color: '#b80404' }}>DGBird Media</a></span>
        </h6>
      </div>
    </footer>
  );
};

export default Footer;
